import styled from '@emotion/styled';
import { greens, greys, white } from '@/styles/colors';
import { sansSerif } from '@/styles/typography';

// Figma: Corporate Account — Discovery, "Operational · Stores". The design covers the location
// selector, the seven-day hours grid, the holiday toggles and the save bar. The location-details
// form it does not draw is restyled to match rather than dropped — see DESIGN_COVERS.

const HEADER_GREY = '#8A8F98';

export const Panel = styled.div`
    ${sansSerif}
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Toolbar = styled.div`
    align-items: flex-end;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`;

export const FieldLabel = styled.span`
    color: ${HEADER_GREY};
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.7px;
    margin-bottom: 6px;
    text-transform: uppercase;
`;

export const SectionTitle = styled.h3`
    align-items: center;
    color: #0c0b1d;
    display: flex;
    font-size: 20px;
    font-weight: 800;
    gap: 8px;
    margin: 0;
`;

export const SubTitle = styled.span`
    color: ${greys.secondary};
    display: block;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 12px;
`;

export const Fieldset = styled.div`
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(${({ columns }) => columns || 2}, minmax(0, 1fr));
`;

export const FieldRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
`;

export const CheckboxRow = styled.div`
    align-items: center;
    display: flex;
    gap: 4px;
`;

// Seven equal columns on the design; they collapse rather than overflow on a narrow viewport.
export const HoursGrid = styled.div`
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(7, minmax(0, 1fr));

    @media (max-width: 1100px) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    @media (max-width: 700px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const DayColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const HolidayGrid = styled.div`
    display: grid;
    gap: 4px 48px;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;

export const HolidayColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Divider = styled.hr`
    border: none;
    border-top: 1px solid ${greys.border};
    margin: 0;
`;

export const SaveRow = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`;

export const ValidationNote = styled.span`
    color: ${({ error }) => (error ? '#C0392B' : greens.primary)};
    font-size: 13px;
    font-weight: 600;
`;

export const WelcomeNote = styled.div`
    background: ${white.secondary};
    border: 1px solid ${greys.border};
    border-left: 3px solid ${greens.primary};
    border-radius: 8px;
    color: ${greys.secondary};
    font-size: 13.5px;
    line-height: 1.6;
    padding: 16px 20px;
`;

// Names the locations holding up a save, each one clickable so the user can go fix it.
export const BlockingNote = styled.div`
    background: #fdf3f2;
    border: 1px solid #f3d0cb;
    border-radius: 8px;
    color: #8a2c22;
    font-size: 13px;
    line-height: 1.6;
    padding: 12px 16px;

    ul {
        margin: 6px 0 0;
        padding-left: 20px;
    }
`;

export const BlockingLink = styled.button`
    ${sansSerif}
    background: none;
    border: none;
    color: #8a2c22;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    padding: 0;
    text-decoration: underline;
`;
